<script setup lang="ts">
import SettingsBasic from './SettingsBasic.vue';
import PartSelection from "@/components/PartSelection.vue";
</script>

<template>
  <div class="space-y-8 max-w-3xl mx-auto pb-12">
    <PartSelection />
    <!-- Der JSON-Editor-Umschalter lebt vollständig in SettingsBasic (rendert den Editor selbst). -->
    <SettingsBasic />
  </div>
</template>
